module.exports = "/_next/static/images/notif-modal-mask-mobile-7f59f31cbfd39a5c19e84fef7ad88672.png";